<template>
  <div v-show="show" class="su-flex">
    <div class="su-bg">
      <div class="su-close" @click="back()">
        <img
          src="data:image/png;base64,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"
        />
        <span>返回</span>
      </div>
      <img src="https://img.yzcdn.cn/upload_files/2020/03/26/FmJ1IXhO6wnVI31k9neps5oyGPhJ.png" />
      <div class="su-bg-2">
        <img src="https://img.yzcdn.cn/upload_files/2019/11/14/FsmHVwrmBaPLQKd10nrMv0Q1d9H9.png" />
        <div class="su-button">
          <img
            :src="
              isSearch
                ? 'https://img01.yzcdn.cn/upload_files/2021/10/13/Fghz8jlwa-3c9D7IX4n35Z7gIJwl.png'
                : 'https://img.yzcdn.cn/upload_files/2019/11/14/FlKstKP0F_JIJ5U6ilgCszPLCbp2.png'
            "
            @click="emitClick"
          />
          <span v-if="!isSearch">
            没有条形码，
            <a :href="hrefUrl">填写书籍信息</a>
          </span>
        </div>
      </div>
    </div>
    <div class="su-color"></div>
  </div>
</template>
<script>
import { checkScanQrCode } from '@/static/js/zjs'
import { mapGetters } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      scanResult: '' // 扫码结果
    }
  },
  computed: {
    ...mapGetters(['openid']),
    hrefUrl() {
      return '/cms/weixin/hw/toAddNewBook'
    }
  },
  methods: {
    back() {
      this.$emit('on-back')
    },
    emitClick() {
      this.clickScanQRCode()
    },
    //  求书扫码
    clickScanQRCode() {
      this.$wechatJsSdk.then((wx) => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            if (res.errMsg === 'scanQRCode:ok') {
              if (checkScanQrCode(result)) {
                window.location.href = `/cms/webapp/home/answer/#/findbook/findresult?barCode=${result}`
              }
            }
          },
          fail: function(err) {}
        })
      })
    }
  }
}
</script>
<style lang="scss">
.su-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.su-bg {
  width: 100%;
  position: relative;
}

.su-bg img {
  display: block;
  width: 100%;
}

.su-bg-2 {
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  padding: 28vw 25px 0px;
}

.su-bg-2 img {
  display: block;
  width: 100%;
}

.su-color {
  flex-grow: 1;
  flex-basis: 1;
  background-color: #6a6ae1;
}

.su-button {
  width: 60%;
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.su-button img {
  margin-bottom: 4vw;
}

.su-button span {
  font-size: 13px;
}

.su-button a {
  font-size: 13px;
  color: #e6304c;
}

.su-close {
  position: absolute;
  top: 0;
  left: 0;
  padding: 14px 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 103;
}

.su-close img {
  height: 100%;
  width: 22px;
  margin-right: 8px;
}

.su-close span {
  line-height: 1;
  font-size: 15px;
  color: rgba(255, 255, 255, 1);
}
</style>
